var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HorizontalStackChart',{attrs:{"title":_vm.title,"data":_vm.data,"labels":_vm.labels,"ratio":_vm.labels.length > 10 ? true : false}})
}
var staticRenderFns = []

export { render, staticRenderFns }